import React from "react";
import { Link } from "react-router-dom";
import { VideoGallery } from "../components";
import {
	faArrowCircleRight,
	faBook,
	faMap,
	faNewspaper
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPatreon, faYoutube } from "@fortawesome/free-brands-svg-icons";
import BestVids from "../assets/backup/best.json";

const HomePage = () => {
	return (
		<div className="overflow-x-hidden">
			{/* hero  */}
			<section className="px-4 py-16 sm:py-20 mx-auto max-w-7xl">
				<div className="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center">
					<h1 className="mb-6 congress text-4xl font-extrabold leading-none tracking-normal text-gray-900 md:text-6xl md:tracking-tight">
						Author, YouTuber,
						<br />
						<span className="block w-full text-transparent bg-clip-text bg-gradient-to-r from-greene-light to-blue-500 lg:inline">
							Dishelved Goblin
						</span>
					</h1>
					<p className="px-0 mb-6 text-lg text-gray-600 md:text-xl lg:px-24">
						Best-selling author & BookTube personality creating content all
						about Fantasy, including reviews, rankings, discussions, news, &
						more!
					</p>
					<div className="mb-4 space-x-0 md:space-x-2 md:mb-6">
						<Link
							className="inline-flex items-center justify-center w-full mb-2 text-white font-semibold btn btn-primary bg-greene-light hover:bg-greene px-4 py-2 rounded-lg btn-lg sm:w-auto sm:mb-0 transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105 mr-2"
							to="/latest"
						>
							Watch Latest
							<FontAwesomeIcon icon={faArrowCircleRight} className="ml-2" />
						</Link>
						<Link
							className="inline-flex items-center justify-center w-full text-white font-semibold mb-2 bg-greene-light hover:bg-greene px-4 py-2 rounded-lg btn btn-light btn-lg sm:w-auto sm:mb-0 transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105"
							to="/explore"
						>
							Explore Past Videos
							<FontAwesomeIcon icon={faMap} className="ml-2" />
						</Link>
					</div>
				</div>
				<div className="w-full mx-auto mt-8 sm:mt-16 text-center md:w-10/12 bg-gradient-to-r from-greene-light to-blue-500 rounded-lg">
					<img
						src="https://user-images.githubusercontent.com/47064842/115473240-618d7d00-a209-11eb-8778-568185a30c3e.jpg"
						// src="https://images.unsplash.com/photo-1473755504818-b72b6dfdc226?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=967&q=80"
						// src="https://i.pinimg.com/originals/e6/52/be/e652be1d518df2f90172182ce813cc24.png"
						alt="Hero"
						className="w-full h-64 rounded-lg sm:h-auto  shadow-2xl object-cover object-center-top opacity-70"
					/>
				</div>
			</section>
			{/* about  */}
			<section className="px-4 py-24 mx-auto max-w-7xl">
				<div className="grid items-center grid-cols-1 mb-24 md:grid-cols-2 gap-y-10 md:gap-y-32 gap-x-10 md:gap-x-24">
					<div className="text-left">
						<h2 className="mb-4 text-2xl congress font-extrabold tracking-tight text-black md:leading-tight text-left md:text-4xl">
							Creating High-Quality Content For Over 5 Years
						</h2>
						<p className="mb-8 text-base  text-gray-600 text-left md:text-lg">
							Daniel Greene is your go-to self-proclaimed "YouTube Fantasy
							Nerd." He releases videos several times a week about fantasy
							books, including reviews, rankings, discussions, news, countdowns,
							hot takes, and more. He also commonly works with other awesome
							BookTubers. Daniel's passion about Fantasy is core to his content
							— he is well-known for being a huge fan of The Wheel of Time
							series by Robert Jordon.
						</p>
						<Link
							to="/news"
							className="w-full btn btn-dark text-white font-semibold bg-greene-light hover:bg-greene rounded-lg px-6 py-3 btn-lg sm:w-auto  transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105 "
						>
							View Fantasy News
							<FontAwesomeIcon icon={faNewspaper} className="ml-2" />
						</Link>
					</div>
					<img
						className="w-full bg-gray-200 rounded-lg object-cover object-center-top h-72 sm:h-full"
						alt="portrait"
						src="https://user-images.githubusercontent.com/47064842/115474172-e200ad80-a20a-11eb-9bdc-9434fc0e9519.png"
					/>
				</div>
				<div className="grid flex-col-reverse items-center grid-cols-1 md:grid-cols-2 gap-y-10 md:gap-y-32 gap-x-10 md:gap-x-24">
					<div className="order-none md:order-2 text-left">
						<h2 className="mb-4 text-2xl congress font-extrabold tracking-tight  text-black md:leading-tight text-left md:text-4xl">
							Author, Reader, Fan
						</h2>
						<p className="mb-8 text-base text-gray-600 text-left md:text-lg">
							In addition to being a content-creator, Daniel is a bestselling
							author. His debut novel "Breach of Peace" was recently released to
							critical and commercial success. He is incredibly grateful to
							everyone who supported him throughout his journey, and has worked
							to illuminate what the process of publishing is like in an effort
							to help others interested in a similar path. Daniel plans to write
							a trilogy of novellas before beginning a longer series.
						</p>
						<Link
							to="/books"
							className="w-full btn btn-dark text-white font-semibold bg-greene-light hover:bg-greene rounded-lg px-6 py-3 btn-lg sm:w-auto transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105 "
						>
							View Breach of Peace
							<FontAwesomeIcon icon={faBook} className="ml-2" />
						</Link>
					</div>
					<img
						className="w-full h-72 sm:h-full bg-gray-200 rounded-lg  object-cover object-center-top"
						alt="portrait"
						src="https://user-images.githubusercontent.com/47064842/115315554-9506d380-a145-11eb-96f7-fa4f7426e152.png"
						// src="https://user-images.githubusercontent.com/47064842/115313573-84ecf500-a141-11eb-93eb-96207f0aa2ae.png"
					/>
				</div>
			</section>

			{/* pop vids */}
			{/*TODO: determine if desired:
			 <section className="pt-24 mb-6 mx-auto px-4 max-w-7xl lg:max-w-9xl ml-10 md:ml-16 lg:ml-24">
				<h2 className="mb-2 text-3xl congress font-extrabold leading-tight text-gray-900">
					Popular Videos
				</h2>
				<p className="mb-6 text-lg text-gray-500">
					Fun, entertaining, and engaging content! These are the most viewed
					videos on the channel.
				</p>
				<a
					href="https://www.youtube.com/channel/UCw--xPGVVxYzRsWyV1nFqgg/videos?view=0&sort=p"
					className="w-full btn btn-primary btn-lg text-white font-semibold bg-greene-light hover:bg-greene px-5 py-3 rounded-lg  transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105  hover:shadow-xl sm:w-auto "
				>
					See More
					<FontAwesomeIcon icon={faYoutube} className="ml-2" />
				</a>
			</section> */}
			{/* <VideoGallery videos={videos.slice(0, 9)} /> */}

			{/* patreon cta */}
			<section className="px-6 sm:px-12 md:px-24 py-20 mx-auto max-w-screen bg-gray-50">
				<div className="grid items-center grid-cols-1 lg:grid-cols-2 gap-y-10 lg:gap-y-32 gap-x-10 lg:gap-x-24">
					<div>
						<h2 className="mb-3 congress text-3xl font-extrabold leading-tight tracking-tight  text-black text-left md:text-4xl">
							Become a Patron
						</h2>
						<p className="mb-8 text-lg  text-gray-600 text-left md:text-xl">
							Support the Daniel Greene YouTube channel and unlock all kinds of
							awesome perks!
						</p>
						<a
							href="https://www.patreon.com/DanielBGreene"
							className="w-full btn btn-primary btn-lg text-white font-semibold bg-greene-light hover:bg-greene px-6 py-3 rounded-lg  transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105  hover:shadow-xl sm:w-auto"
						>
							Join Patreon Today
							<FontAwesomeIcon icon={faPatreon} className="ml-2" />
						</a>
					</div>
					<div className="flex flex-col flex-grow space-y-5">
						<div className="flex items-start">
							<svg
								viewBox="0 0 20 20"
								fill="currentColor"
								className="flex-none w-5 h-5 mt-1 mr-2 text-primary text-greene"
							>
								<path
									fillRule="evenodd"
									d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
									clipRule="evenodd"
								></path>
							</svg>
							<p className="text-lg text-gray-700">
								Watch with an ad-blocker guilt free
							</p>
						</div>
						<div className="flex items-start">
							<svg
								viewBox="0 0 20 20"
								fill="currentColor"
								className="flex-none w-5 h-5 mt-1 mr-2 text-primary text-greene"
							>
								<path
									fillRule="evenodd"
									d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
									clipRule="evenodd"
								></path>
							</svg>
							<p className="text-lg text-gray-700 ">
								Get a shoutout at the end of all videos with your name appearing
								alongside other wonderful contributors
							</p>
						</div>
						<div className="flex items-start">
							<svg
								viewBox="0 0 20 20"
								fill="currentColor"
								className="flex-none w-5 h-5 mt-1 mr-2 text-primary text-greene"
							>
								<path
									fillRule="evenodd"
									d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
									clipRule="evenodd"
								></path>
							</svg>
							<p className="text-lg text-gray-700">
								Personal thank you at the end of the next video calling you out
								for being such an awesome supporter
							</p>
						</div>
						<div className="flex items-start">
							<svg
								viewBox="0 0 20 20"
								fill="currentColor"
								className="flex-none w-5 h-5 mt-1 mr-2 text-primary text-greene"
							>
								<path
									fillRule="evenodd"
									d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
									clipRule="evenodd"
								></path>
							</svg>
							<p className="text-lg text-gray-700">
								Unlock exclusive Patreon content
							</p>
						</div>
						<div className="flex items-start">
							<svg
								viewBox="0 0 20 20"
								fill="currentColor"
								className="flex-none w-5 h-5 mt-1 mr-2 text-primary text-greene"
							>
								<path
									fillRule="evenodd"
									d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
									clipRule="evenodd"
								></path>
							</svg>
							<p className="text-lg text-gray-700">Discord perks</p>
						</div>
					</div>
				</div>
			</section>

			{/* fav vids  */}
			<section className="pt-24 mx-auto px-4 max-w-7xl lg:max-w-9xl mb-6 text-right mr-6 md:mr-16 lg:mr-24">
				<h2 className="mb-2 text-3xl congress font-extrabold leading-tight text-gray-900 ">
					"Best" Videos
				</h2>
				<p className="mb-6 text-lg font-regular text-gray-500">
					"These are my best... I think?"
					<br className="sm:hidden" /> — Daniel Greene
				</p>
				<a
					href="https://www.youtube.com/playlist?list=PLGye3IeTsQJko_7pK3ZU885IA985qnW2w"
					className="w-full btn btn-primary btn-lg text-white font-semibold bg-greene-light hover:bg-greene px-5 py-3 rounded-lg  transition duration-500 ease-in-out transform rounded shadow-xl hover:shadow-xl hover:scale-105  hover:shadow-xl sm:w-auto "
				>
					See More
					<FontAwesomeIcon icon={faYoutube} className="ml-2" />
				</a>
			</section>
			<VideoGallery videos={BestVids} />
		</div>
	);
};
export default HomePage;
